<template>
    <!-- Start Multiple Choice Results -->
    <div>
        <l-surveys-insights-filters
            :survey="survey"
            :allowed-filters="['period', 'question', 'sentiment', 'replied', 'classify']"
            @change="onFilterChange"
        ></l-surveys-insights-filters>
        <hr />
        <div v-show="!multi.results.length" class="text-center">
            <img alt="" :src="emptyIcon" class="placeholder-list" />
            <h4 class="color-grey">
                <span>{{ $t("surveys.details.labelNoData") }} </span>
            </h4>
        </div>

        <!-- End no results message -->

        <div v-show="multi.results.length" class="row">
            <div class="col-md-12">
                <div
                    v-for="question in multi.results"
                    :key="question._id"
                    class="multi-question row"
                >
                    <div class="col-md-12">
                        <span class="multi-question-name">{{ question.name }}</span>
                        <div class="multi-question-answers">
                            <div
                                v-for="answer in question.answers"
                                :key="answer._id"
                                class="multi-question-answer"
                            >
                                <span class="multi-question-answer-name">{{ answer.name }}</span>
                                <span class="multi-question-answer-bar">
                                    <div
                                        v-b-popover.hover.right="{
                                            content:
                                                ((answer.count / question.total) * 100).toFixed(0) +
                                                '%',
                                        }"
                                        class="progress progress-sm"
                                    >
                                        <div
                                            v-show="answer.count > 0"
                                            class="progress-bar progress-bar-success"
                                            role="progressbar"
                                            :style="
                                                `width:${(answer.count / question.total) * 100}%`
                                            "
                                        ></div>
                                    </div>
                                    <span class="multi-question-answer-count">{{
                                        answer.count
                                    }}</span>
                                </span>

                                <div
                                    class="multi-question-answer-senders"
                                    style="margin-left: 12px;"
                                >
                                    <l-profile-picture
                                        v-for="user in (answer.senders || []).slice(0, 5)"
                                        :key="user._id"
                                        class="multi-question-answer-sender"
                                        :user="user"
                                        :show-popover-name="true"
                                        size="s"
                                        data-test-id="feedback-sender-picture"
                                    />
                                    <span v-show="answer.senders.length > 5">
                                        <span>
                                            {{
                                                $t("surveys.details.multiChoiceAnswerSendersMore", {
                                                    count: answer.senders.length - 5,
                                                })
                                            }}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Multiple Choice Results -->
</template>

<script>
import { mapGetters } from "vuex";

import icon from "@/img/icons/surveys.png";
import emptyIcon from "@/img/icons/nodata.png";
import LProfilePicture from "@/components/LProfilePicture";
import LSurveysInsightsFilters from "@/components/LSurveysInsightsFilters.vue";

export default {
    components: {
        LProfilePicture,
        LSurveysInsightsFilters,
    },
    props: {
        survey: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            filters: {},
            error: false,
        };
    },
    computed: {
        ...mapGetters({
            multi: "surveys/surveys/multi",
        }),
    },
    watch: {
        multi: {
            immediate: true,
            handler(multi) {
                this.$emit("change", multi?.minObsAnonymity);
            },
        },
    },

    created() {
        this.icon = icon;
        this.emptyIcon = emptyIcon;
    },
    methods: {
        onFilterChange(type, { filters }) {
            this.filters = filters;
            this.$store.dispatch("surveys/surveys/getMulti", {
                payload: {
                    survey: this.$route.params.id,
                    filterBy: filters,
                    format: "json",
                },
            });
        },
        export() {
            this.$store.dispatch("surveys/surveys/exportMulti", {
                payload: {
                    survey: this.$route.params.id,
                    filterBy: this.filters,
                    format: "xlsx",
                },
            });
        },
    },
};
</script>

<style scoped></style>
